var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlobAtendimentoDireito(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 158,
    viewBox: "0 0 72 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9508 68.6854C16.9508 23.2233 52.3123 -4.05403 94.7463 0.492181C130.108 4.12915 144.252 32.3157 172.542 36.8619C207.903 42.3174 243.265 23.2233 260.946 59.593C278.627 95.9627 264.482 136.879 232.656 150.517C193.759 166.884 158.397 141.425 123.036 145.971C84.1377 150.972 25.3167 171.829 4.09972 140.006C-10.0449 119.093 16.9508 91.4165 16.9508 68.6854Z",
    fill: "#3E6B72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlobAtendimentoDireito);
export default __webpack_public_path__ + "static/media/blobAtendimentoDireito.df8f9dcd7d6f8a8999aceaf0b0bfe8d8.svg";
export { ForwardRef as ReactComponent };